/** A filename-safe slug of a display name (`Kitchen Remodel` → `kitchen-remodel`); `fallback` when nothing survives. */
export function slug(name: string, fallback = 'download'): string {
  const out = name
    .normalize('NFKD')
    // Strip the combining diacritical marks NFKD split off (U+0300–U+036F, written literally).
    .replace(/[̀-ͯ]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  return out.length > 0 ? out : fallback;
}
